document.addEventListener('DOMContentLoaded', () => {
  const SCROLL_LOCK_CLASS = 'scroll-lock';
  const ANNOUNCEMENT_STORAGE_KEY = 'greenfur-announcement-dismissed';

  function showToast(message, type = 'success') {
    const existing = document.querySelector('.toast-notification');
    if (existing) existing.remove();

    const toast = document.createElement('div');
    toast.className = `toast-notification toast-notification--${type}`;
    toast.textContent = message;
    toast.setAttribute('role', 'alert');
    toast.setAttribute('aria-live', 'polite');

    const style = document.createElement('style');
    style.textContent = `
      .toast-notification {
        position: fixed;
        top: 20px;
        right: 20px;
        padding: 14px 20px;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 500;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        z-index: 10000;
        animation: toast-slide-in 0.3s ease;
      }
      .toast-notification--success { background: #22c55e; color: #fff; }
      .toast-notification--error { background: #ef4444; color: #fff; }
      @keyframes toast-slide-in {
        from { transform: translateX(100%); opacity: 0; }
        to { transform: translateX(0); opacity: 1; }
      }
    `;
    if (!document.querySelector('#toast-styles')) {
      style.id = 'toast-styles';
      document.head.appendChild(style);
    }

    document.body.appendChild(toast);
    setTimeout(() => toast.remove(), 3000);
  }

  const menuToggle = document.querySelector('.header__menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      const isOpen = mobileNav.classList.contains('is-open');
      mobileNav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', !isOpen);
      document.body.classList.toggle(SCROLL_LOCK_CLASS, !isOpen);
    });

    document.addEventListener('click', (e) => {
      if (mobileNav.classList.contains('is-open') && !mobileNav.contains(e.target) && !menuToggle.contains(e.target)) {
        mobileNav.classList.remove('is-open');
        menuToggle.setAttribute('aria-expanded', 'false');
        document.body.classList.remove(SCROLL_LOCK_CLASS);
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) {
        mobileNav.classList.remove('is-open');
        menuToggle.setAttribute('aria-expanded', 'false');
        document.body.classList.remove(SCROLL_LOCK_CLASS);
      }
    });
  }

  const header = document.querySelector('.header');
  if (header) {
    const scrollThreshold = 100;
    const handleScroll = () => {
      const currentScroll = window.scrollY || document.documentElement.scrollTop;
      header.classList.toggle('header--scrolled', currentScroll > scrollThreshold);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
  }

  const animateElements = document.querySelectorAll('.animate');
  if (animateElements.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate--visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    animateElements.forEach((el) => observer.observe(el));
  }

  document.querySelectorAll('.product__quantity-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      const wrapper = btn.closest('.product__quantity-input');
      if (!wrapper) return;
      const input = wrapper.querySelector('input[type="number"]');
      if (!input) return;
      let val = parseInt(input.value, 10) || 1;
      const max = parseInt(input.max, 10) || 9999;
      if (btn.dataset.action === 'minus') {
        val = Math.max(1, val - 1);
      } else {
        val = Math.min(max, val + 1);
      }
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  // Cart popup helpers
  function openCartPopup(product, cart) {
    const popup = document.getElementById('CartPopup');
    if (!popup) return;

    const imgContainer = document.getElementById('CartPopupImage');
    if (imgContainer) {
      imgContainer.innerHTML = product.image
        ? `<img src="${product.image}" alt="${product.title}" width="200" height="200">`
        : '';
    }

    const titleEl = document.getElementById('CartPopupProductTitle');
    if (titleEl) titleEl.textContent = product.product_title || product.title;

    const variantEl = document.getElementById('CartPopupVariant');
    if (variantEl) {
      if (product.variant_title && product.variant_title !== 'Default Title') {
        variantEl.textContent = product.variant_title;
        variantEl.style.display = '';
      } else if (product.product_type) {
        variantEl.textContent = 'Product type: ' + product.product_type;
        variantEl.style.display = '';
      } else {
        variantEl.style.display = 'none';
      }
    }

    const qtyPriceEl = document.getElementById('CartPopupQtyPrice');
    if (qtyPriceEl) {
      const price = (product.final_line_price || product.line_price || product.price) / 100;
      const qty = product.quantity || 1;
      qtyPriceEl.textContent = `${qty} x $${price.toFixed(2)}`;
    }

    const subtotalEl = document.getElementById('CartPopupSubtotal');
    if (subtotalEl) subtotalEl.textContent = '$' + (cart.total_price / 100).toFixed(2);

    const countEl = document.getElementById('CartPopupItemCount');
    if (countEl) countEl.textContent = `Your cart contains ${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`;

    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeCartPopup() {
    const popup = document.getElementById('CartPopup');
    if (!popup) return;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-cart-popup-close]').forEach((btn) => {
    btn.addEventListener('click', closeCartPopup);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeCartPopup();
  });

  // Prevent card ATC forms from navigating to product page
  document.querySelectorAll('.product-card__atc-form').forEach((form) => {
    form.addEventListener('click', (e) => e.stopPropagation());
  });

  // Add to cart with popup
  document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      const submitBtn = form.querySelector('[type="submit"]');
      const originalHTML = submitBtn?.innerHTML;
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = '<span>Adding...</span>';
      }

      try {
        const formData = new FormData(form);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        const data = await res.json();

        if (!res.ok) throw new Error(data.description || 'Could not add to cart');

        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        const headerCount = document.querySelector('.header__cart-count');
        if (headerCount) headerCount.textContent = cart.item_count;

        openCartPopup(data, cart);

        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = originalHTML;
        }
      } catch (err) {
        showToast(err.message || 'Something went wrong', 'error');
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = originalHTML;
        }
      }
    });
  });

  document.addEventListener('change', async (e) => {
    const input = e.target;
    if (!input.name?.startsWith('updates[') && !input.dataset?.lineKey) return;
    const key = input.dataset?.lineKey || input.name.replace(/^updates\[|\]$/g, '');
    if (!key) return;

    const quantity = input.type === 'number' ? parseInt(input.value, 10) : parseInt(input.options?.[input.selectedIndex]?.value, 10);
    if (isNaN(quantity) || quantity < 0) return;

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description);

      const sectionId = document.querySelector('[data-cart-section-id]')?.dataset.cartSectionId || 'main-cart';
      const sectionRes = await fetch(`${window.location.pathname}?sections=${sectionId}`);
      const sectionData = await sectionRes.json();
      const html = sectionData[sectionId];
      const cartSection = document.querySelector(`[data-cart-section-id="${sectionId}"]`) || document.querySelector('.cart');
      if (cartSection && html) cartSection.innerHTML = html;
    } catch (err) {
      showToast(err.message || 'Could not update cart', 'error');
    }
  });

  const announcementBar = document.querySelector('.announcement-bar');
  const announcementDismiss = document.querySelector('.announcement-bar__dismiss');
  if (announcementBar && announcementDismiss && !sessionStorage.getItem(ANNOUNCEMENT_STORAGE_KEY)) {
    announcementDismiss.addEventListener('click', () => {
      announcementBar.style.display = 'none';
      sessionStorage.setItem(ANNOUNCEMENT_STORAGE_KEY, 'true');
    });
  } else if (announcementBar && sessionStorage.getItem(ANNOUNCEMENT_STORAGE_KEY)) {
    announcementBar.style.display = 'none';
  }

  const productGallery = document.querySelector('.product-gallery');
  if (productGallery) {
    const mainImage = productGallery.querySelector('.product-gallery__main img');
    const thumbnails = productGallery.querySelectorAll('.product-gallery__thumb');
    thumbnails.forEach((thumb) => {
      thumb.addEventListener('click', (e) => {
        e.preventDefault();
        const img = thumb.querySelector('img');
        const src = img?.dataset.src || img?.src;
        if (mainImage && src) {
          mainImage.src = src;
          mainImage.srcset = img?.dataset.srcset || img?.srcset || '';
          thumbnails.forEach((t) => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
        }
      });
    });
  }

  // Product tabs
  // Collection sort
  const sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  // Collection view toggle (grid/list)
  const viewBtns = document.querySelectorAll('[data-view]');
  const collectionGrid = document.getElementById('CollectionGrid');
  if (viewBtns.length && collectionGrid) {
    const saved = localStorage.getItem('collection-view');
    if (saved) {
      collectionGrid.dataset.view = saved;
      viewBtns.forEach((b) => {
        b.classList.toggle('is-active', b.dataset.view === saved);
      });
    }

    document.querySelectorAll('.collection-toolbar__view-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        const view = btn.dataset.view;
        collectionGrid.dataset.view = view;
        localStorage.setItem('collection-view', view);
        document.querySelectorAll('.collection-toolbar__view-btn').forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
      });
    });
  }

  // Cart note toggle
  const noteToggle = document.querySelector('[data-note-toggle]');
  if (noteToggle) {
    noteToggle.addEventListener('click', () => {
      const note = noteToggle.closest('.cart__note-section').querySelector('.cart__note');
      if (note) {
        const isHidden = note.style.display === 'none';
        note.style.display = isHidden ? 'block' : 'none';
        if (isHidden) note.focus();
      }
    });
  }

  // Product tabs
  const tabNav = document.querySelector('.product-tabs__nav');
  if (tabNav) {
    tabNav.addEventListener('click', (e) => {
      const btn = e.target.closest('.product-tabs__btn');
      if (!btn) return;
      const tabId = btn.dataset.tab;
      const container = btn.closest('.product-tabs');

      container.querySelectorAll('.product-tabs__btn').forEach((b) => b.classList.remove('is-active'));
      container.querySelectorAll('.product-tabs__panel').forEach((p) => p.classList.remove('is-active'));

      btn.classList.add('is-active');
      const panel = container.querySelector(`[data-panel="${tabId}"]`);
      if (panel) panel.classList.add('is-active');

    });
  }

  // Clicking the star rating near the title scrolls to and opens the Reviews tab
  const ratingLink = document.querySelector('a.product__rating[href="#reviews"]');
  if (ratingLink) {
    ratingLink.addEventListener('click', function(e) {
      e.preventDefault();
      var reviewsTab = document.getElementById('reviews-tab');
      if (reviewsTab) {
        reviewsTab.click();
        reviewsTab.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  // Product image zoom
  const zoomContainer = document.querySelector('[data-zoom]');
  if (zoomContainer) {
    const zoomImg = zoomContainer.querySelector('img');
    const lens = zoomContainer.querySelector('.product__zoom-lens');
    const result = zoomContainer.querySelector('.product__zoom-result');

    function initZoom() {
      const hiResSrc = zoomImg.dataset.zoomSrc || zoomImg.src;
      result.style.backgroundImage = `url("${hiResSrc}")`;

      const cx = result.offsetWidth / lens.offsetWidth;
      const cy = result.offsetHeight / lens.offsetHeight;
      result.style.backgroundSize = `${zoomImg.width * cx}px ${zoomImg.height * cy}px`;
    }

    zoomContainer.addEventListener('mouseenter', initZoom);

    zoomContainer.addEventListener('mousemove', (e) => {
      const rect = zoomContainer.getBoundingClientRect();
      let x = e.clientX - rect.left;
      let y = e.clientY - rect.top;

      const lw = lens.offsetWidth / 2;
      const lh = lens.offsetHeight / 2;
      x = Math.max(lw, Math.min(x, rect.width - lw));
      y = Math.max(lh, Math.min(y, rect.height - lh));

      lens.style.left = `${x - lw}px`;
      lens.style.top = `${y - lh}px`;

      const cx = result.offsetWidth / lens.offsetWidth;
      const cy = result.offsetHeight / lens.offsetHeight;
      result.style.backgroundPosition = `-${(x - lw) * cx}px -${(y - lh) * cy}px`;
    });
  }

  // Product thumbnail gallery
  const mainProductImage = document.querySelector('.product__media-main img');
  const productThumbs = document.querySelectorAll('.product__media-thumb');
  if (mainProductImage && productThumbs.length) {
    productThumbs.forEach((thumb) => {
      thumb.addEventListener('click', (e) => {
        e.preventDefault();
        const img = thumb.querySelector('img') || thumb;
        const fullSrc = img.src.replace(/width=150/, 'width=800');
        const zoomSrc = img.src.replace(/width=150/, 'width=1600');
        mainProductImage.src = fullSrc;
        mainProductImage.dataset.zoomSrc = zoomSrc;
        productThumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  document.querySelectorAll('[data-slideshow]').forEach((slideshow) => {
    const slides = slideshow.querySelectorAll('.slideshow__slide');
    const dots = slideshow.querySelectorAll('.slideshow__dot');
    const prevBtn = slideshow.querySelector('[data-slide-prev]');
    const nextBtn = slideshow.querySelector('[data-slide-next]');
    const autoplay = slideshow.dataset.autoplay === 'true';
    const interval = (parseInt(slideshow.dataset.interval, 10) || 5) * 1000;
    let current = 0;
    let timer = null;

    if (slides.length < 2) return;

    function goTo(index) {
      slides[current].classList.remove('slideshow__slide--active');
      if (dots[current]) dots[current].classList.remove('slideshow__dot--active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('slideshow__slide--active');
      if (dots[current]) dots[current].classList.add('slideshow__dot--active');
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      if (autoplay) timer = setInterval(next, interval);
    }

    function resetAutoplay() {
      clearInterval(timer);
      startAutoplay();
    }

    if (prevBtn) prevBtn.addEventListener('click', () => { prev(); resetAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { next(); resetAutoplay(); });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        goTo(parseInt(dot.dataset.slideDot, 10));
        resetAutoplay();
      });
    });

    let touchStartX = 0;
    slideshow.addEventListener('touchstart', (e) => { touchStartX = e.changedTouches[0].screenX; }, { passive: true });
    slideshow.addEventListener('touchend', (e) => {
      const diff = e.changedTouches[0].screenX - touchStartX;
      if (Math.abs(diff) > 50) {
        diff > 0 ? prev() : next();
        resetAutoplay();
      }
    }, { passive: true });

    startAutoplay();
  });

  // --- Search overlay with predictive search ---
  const searchOverlay = document.getElementById('SearchOverlay');
  const searchToggleBtn = document.querySelector('.header__search-toggle');
  const searchInput = document.getElementById('SearchInput');
  const searchResultsContainer = document.getElementById('SearchResults');

  if (searchOverlay && searchToggleBtn) {
    let searchDebounceTimer = null;
    let currentQuery = '';
    let abortController = null;

    function openSearch() {
      searchOverlay.classList.add('is-open');
      searchOverlay.setAttribute('aria-hidden', 'false');
      searchToggleBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (searchInput) searchInput.focus();
        });
      });
    }

    function closeSearch() {
      searchOverlay.classList.remove('is-open');
      searchOverlay.setAttribute('aria-hidden', 'true');
      searchToggleBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      if (searchInput) searchInput.value = '';
      if (searchResultsContainer) searchResultsContainer.innerHTML = '';
      currentQuery = '';
      if (abortController) abortController.abort();
      searchToggleBtn.focus();
    }

    searchToggleBtn.addEventListener('click', openSearch);

    searchOverlay.addEventListener('click', (e) => {
      if (e.target.closest('[data-search-close]')) closeSearch();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && searchOverlay.classList.contains('is-open')) {
        closeSearch();
      }
    });

    function formatPrice(value) {
      const num = parseFloat(value);
      if (isNaN(num)) return '';
      return '$' + num.toFixed(2);
    }

    function renderResults(data) {
      if (!searchResultsContainer) return;

      const resources = data.resources?.results;
      if (!resources) {
        searchResultsContainer.innerHTML = '';
        return;
      }

      const products = resources.products || [];
      const pages = resources.pages || [];
      const articles = resources.articles || [];
      const collections = resources.collections || [];
      const hasResults = products.length || pages.length || articles.length || collections.length;

      if (!hasResults) {
        searchResultsContainer.innerHTML = '<p class="search-results__empty">No results found. Try a different search term.</p>';
        return;
      }

      let html = '';

      if (products.length) {
        html += '<div class="search-results__group">';
        html += '<h4 class="search-results__heading">Products</h4>';
        products.forEach((product) => {
          const image = product.image || product.featured_image?.url || '';
          const price = product.price_min != null ? formatPrice(product.price_min) : formatPrice(product.price);
          html += `<a href="${product.url}" class="search-results__item">`;
          if (image) {
            html += `<div class="search-results__item-image"><img src="${image}" alt="" width="48" height="48" loading="lazy"></div>`;
          }
          html += '<div class="search-results__item-info">';
          html += `<span class="search-results__item-title">${product.title}</span>`;
          if (product.vendor) {
            html += `<span class="search-results__item-meta">${product.vendor}</span>`;
          }
          html += '</div>';
          if (price) {
            html += `<span class="search-results__item-price">${price}</span>`;
          }
          html += '</a>';
        });
        html += '</div>';
      }

      if (collections.length) {
        html += '<div class="search-results__group">';
        html += '<h4 class="search-results__heading">Collections</h4>';
        collections.forEach((col) => {
          html += `<a href="${col.url}" class="search-results__item">`;
          html += '<div class="search-results__item-info">';
          html += `<span class="search-results__item-title">${col.title}</span>`;
          html += '</div>';
          html += '</a>';
        });
        html += '</div>';
      }

      if (articles.length) {
        html += '<div class="search-results__group">';
        html += '<h4 class="search-results__heading">Articles</h4>';
        articles.forEach((article) => {
          const image = article.image || article.featured_image?.url || '';
          html += `<a href="${article.url}" class="search-results__item">`;
          if (image) {
            html += `<div class="search-results__item-image"><img src="${image}" alt="" width="48" height="48" loading="lazy"></div>`;
          }
          html += '<div class="search-results__item-info">';
          html += `<span class="search-results__item-title">${article.title}</span>`;
          html += `<span class="search-results__item-meta">Blog</span>`;
          html += '</div>';
          html += '</a>';
        });
        html += '</div>';
      }

      if (pages.length) {
        html += '<div class="search-results__group">';
        html += '<h4 class="search-results__heading">Pages</h4>';
        pages.forEach((page) => {
          html += `<a href="${page.url}" class="search-results__item">`;
          html += '<div class="search-results__item-info">';
          html += `<span class="search-results__item-title">${page.title}</span>`;
          html += '</div>';
          html += '</a>';
        });
        html += '</div>';
      }

      const q = encodeURIComponent(currentQuery);
      html += `<a href="/search?q=${q}" class="search-results__view-all">View all results &rarr;</a>`;

      searchResultsContainer.innerHTML = html;
    }

    async function fetchPredictiveSearch(query) {
      if (abortController) abortController.abort();
      abortController = new AbortController();

      try {
        const params = new URLSearchParams({
          q: query,
          'resources[type]': 'product,collection,article,page',
          'resources[limit]': '4'
        });
        const res = await fetch(`/search/suggest.json?${params}`, {
          signal: abortController.signal
        });
        if (!res.ok) return;
        const data = await res.json();
        if (query === currentQuery) renderResults(data);
      } catch (err) {
        if (err.name !== 'AbortError') console.error('Predictive search error:', err);
      }
    }

    if (searchInput) {
      searchInput.addEventListener('input', () => {
        const query = searchInput.value.trim();
        currentQuery = query;
        clearTimeout(searchDebounceTimer);

        if (!query) {
          if (searchResultsContainer) searchResultsContainer.innerHTML = '';
          return;
        }

        if (searchResultsContainer) {
          searchResultsContainer.innerHTML = '<div class="search-results__loading"><span class="search-results__spinner"></span>Searching...</div>';
        }

        searchDebounceTimer = setTimeout(() => fetchPredictiveSearch(query), 300);
      });

      searchInput.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          const firstResult = searchResultsContainer?.querySelector('.search-results__item');
          if (firstResult) firstResult.focus();
        }
      });
    }

    if (searchResultsContainer) {
      searchResultsContainer.addEventListener('keydown', (e) => {
        const items = [...searchResultsContainer.querySelectorAll('.search-results__item, .search-results__view-all')];
        const idx = items.indexOf(document.activeElement);
        if (idx === -1) return;

        if (e.key === 'ArrowDown') {
          e.preventDefault();
          if (idx < items.length - 1) items[idx + 1].focus();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          if (idx > 0) items[idx - 1].focus();
          else if (searchInput) searchInput.focus();
        }
      });
    }
  }
});
